import oInfo from "../info.json";

//Multimedia
import SplashImage from "../Multimedia/Images/SplashImage.jpg";

const SplashContainer = () => {
  const { sHeader, sSubHeader, sContent } = oInfo.oSplashPage;
  return (
    <main className="flex-row card" id="about-section">
      <div className="flex-column flex-center card-content-column">
        <h1 className="card-header">{sHeader}</h1>
        <h2 className="card-subheader banner-background">
          <span className="subheader-span">{sSubHeader}</span>
        </h2>
        <p className="card-content">{sContent}</p>
        {/* TODO: Add functionality to this button */}
        {/* <button className="btn">
          <span>{sButtonText}</span>
        </button> */}
      </div>
      <div className="flex-column">
        <img src={SplashImage} alt="Splash" className="card-img" />
      </div>
    </main>
  );
};

export default SplashContainer;
